import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import StageActionToolbar from '../generic/StageActionToolbar';

import '../../../../../styles/Icons.scss';

interface ClientContactStagingPageArgs {
    conversionId: string,
}

type ClientContactStagingPageProps = RouteComponentProps<ClientContactStagingPageArgs>;

export class ClientContactStagingPage extends React.Component<ClientContactStagingPageProps>{
    public render() {
        const conversionId = this.props.match.params.conversionId;

        return (
            <>
                <StageActionToolbar
                    conversionId={conversionId}
                    sectionId='clientcontacts'
                    tierGate='tier3'
                    noMapping={true}
                    filter={''}
                />
            </>
        );
    }
}